import React from 'react'
import css from './Legend.css'

function Legend(props) {
  return (
    <div className={css.legend}>
      {props.payload.map((entry, index) => (
        <span key={`item-${index}`}>
          <span
            className={css.line}
            style={{
              borderColor: entry.color,
            }}
          />
          <span>{entry.value}</span>
        </span>
      ))}
    </div>
  )
}

export default Legend
